<script>
import Layout from '@layouts/empty'

export default {
  page: {
    title: 'Allbuilds',
    meta: [{ name: 'description', content: 'Loading page...' }],
  },
  components: { Layout },
}
</script>

<template>
  <Layout>
    <v-progress-circular
      :size="30"
      :width="3"
      color="secondary"
      indeterminate
    ></v-progress-circular>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
</style>
